import { Loading } from '../../../Loading'
import { LoaderContainer, LoaderText } from './styles'
export const Loader = () => {
  return (
    <LoaderContainer>
      <LoaderText> Analizando calidad de la imagen... </LoaderText>
      <Loading size='30' />
    </LoaderContainer>
  )
}
